import {twMerge} from "tailwind-merge";

export default function TextInput({
                                      label,
                                      rowLabel = false,
                                      required = false,
                                      classes = {},
                                      buttonText = "",
                                      buttonProps = {},
                                      onButtonClick = () => {},
                                      ...otherProps
                                  }) {

    const {labelClasses = "", inputClasses = "", parentClasses = "", inputParentClasses = ""} = classes;

    return (
        <label className={twMerge(rowLabel ? "block xl:inline-flex xl:items-center" : "", parentClasses)}>
            {
                label ?
                    <p className={twMerge(`text-sm text-pol-gray ${rowLabel ? "mb-2 mr-4 xl:ml-4 xl:mb-0 xl:mr-0" : "mb-2 mr-4"}`, labelClasses)}>
                        {label}
                        {
                            required ? <span className="align-super text-pol-red text-sm">*</span> : null
                        }
                    </p>
                    : null
            }
            <div className={twMerge("relative", inputParentClasses)}>
                <input
                    className={twMerge(`border border-pol-light-4 rounded-2xl pr-4 w-full py-3.5 text-pol-dark placeholder:text-pol-purple-4 placeholder:text-sm outline-none focus:border-pol-main-dark-color duration-300 disabled:cursor-not-allowed ${otherProps.readOnly ? "cursor-pointer" : ""} ${buttonText ? "pl-32" : "pl-4"}`, inputClasses)} {...otherProps}/>
                {buttonText ?
                    <button
                        onClick={onButtonClick}
                        className="absolute btn-gray font-semibold text-sm px-4 py-[0.813rem] whitespace-nowrap left-1 top-1"
                        type="button" {...buttonProps}>{buttonText}</button> : null
                }
            </div>
        </label>
    )
}
